import {
  THEME_PREFERENCES,
  THEME_STORAGE_KEY,
} from "./theme.constants";
import { isThemePreference } from "./themeResolver";

const getThemeStorage = (storage) => storage ?? window.localStorage;

export const readThemePreference = (storage) => {
  const storedPreference = getThemeStorage(storage).getItem(THEME_STORAGE_KEY);

  if (isThemePreference(storedPreference)) return storedPreference;

  return THEME_PREFERENCES.SYSTEM;
};

export const storeThemePreference = (themePreference, storage) => {
  const themeStorage = getThemeStorage(storage);

  if (themePreference === THEME_PREFERENCES.SYSTEM) {
    themeStorage.removeItem(THEME_STORAGE_KEY);
    return;
  }

  themeStorage.setItem(THEME_STORAGE_KEY, themePreference);
};
